<template>
  <div>
    <el-form
      :model="pageMsg"
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm"
    >
      <el-form-item
        label="主页："
        prop="page_id"
        class="pageSelect"
        require
      >
        <el-row>
          <el-col :span="10">
            <page-select
              v-model="pageMsg.page_id"
              :page-list="pageList"
              :account-id="account"
              :target-user-id="targetUserId"
              :load-pages="loadPages"
              @change="selectPage"
              @refresh-pages="getAcoountPages"
              @capacity-loaded="onCapacityLoaded"
            ></page-select>
          </el-col>
          <el-col :span="14">
            <span v-if="objective !== 'PAGE_LIKES'">
              <span style="margin-left: 10px">Instagram账号：</span>
              <el-select
                :class="!pageInstagramsList.length ? 'instagram-sel' : ''"
                v-model="pageMsg.instagram_actor_id"
                placeholder="请选择Instagram账号"
                @change="setMsg"
                filterable
                clearable
              >
                <el-option
                  :label="instagrams.username"
                  :value="instagrams.id"
                  v-for="instagrams in pageInstagramsList"
                  :key="instagrams.id"
                  style="height: 70px"
                >
                  <div class="pageItems">
                    <div class="pageImg">
                      <el-image :src="instagrams.profile_pic"></el-image>
                    </div>
                    <div class="pageMsg">
                      <p>{{ instagrams.username }}</p>
                      <div>编号：{{ instagrams.id }}</div>
                    </div>
                  </div>
                </el-option>
              </el-select>
            </span>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import PageSelect from '@/components/PageSelect/index.vue';
import { pageInstagrams } from '@/api/creatAd';

export default {
  props: ['pageList', 'pageInfo', 'loadPages', 'objective', 'account', 'targetUserId'],
  components: { PageSelect },
  data() {
    return {
      pageMsg: {
        page_id: '',
        instagram_actor_id: '',
      },
      pageInstagramsList: [],
      numMsg: {},
    };
  },
  watch: {
    pageInfo: {
      handler() {
        this.syncPageMsg();
      },
      immediate: true,
      deep: true,
    },
    pageList: {
      handler() {
        this.syncPageMsg();
      },
    },
  },
  methods: {
    syncPageMsg() {
      if (!this.pageList.length || !this.pageInfo) {
        this.pageMsg = { page_id: '', instagram_actor_id: '' };
        return;
      }
      this.pageMsg = JSON.parse(JSON.stringify(this.pageInfo));
      if (this.pageInfo.page_id) {
        this.selectPage(this.pageInfo.page_id);
      }
    },
    selectPage(v) {
      if (!v) return;
      this.$showLoading();
      pageInstagrams({ pageId: v, adAccountId: this.account }, this.targetUserId).then((res) => {
        this.$hideLoading();
        this.pageInstagramsList = res.data || [];
        const ids = this.pageInstagramsList.map((item) => item.id);
        if (!ids.includes(this.pageMsg.instagram_actor_id)) {
          const last = this.pageInstagramsList[this.pageInstagramsList.length - 1];
          this.pageMsg.instagram_actor_id = last?.id || '';
        }
        this.setMsg();
      });
    },
    onCapacityLoaded({ pageId, limit, used }) {
      if (this.pageMsg.page_id === pageId) {
        this.numMsg = {
          limit_on_ads_running_or_in_review: limit,
          ads_running_or_in_review_count: used,
        };
      }
    },
    setMsg() {
      this.$emit('getPageMsg', this.pageMsg);
    },
    getAcoountPages() {
      this.$emit('getPages', true);
    },
  },
};
</script>
